import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { GetAssessmentMAndESelfPage } from '../../redux/actions/assessment'
import MAndESelfProjectListWidgets from '../../widgets/assessment/MAndESelfProjectListWidgets'

export default function MAndESelfMain() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      sessionStorage.removeItem('m_e_s_id')
      sessionStorage.removeItem('project_code')

      const response = await GetAssessmentMAndESelfPage(1, 5)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema.forms?.assessment && <MAndESelfProjectListWidgets schema={schema.forms.assessment} />}
    </SidebarProposal>
  )
}
